import { render, staticRenderFns } from "./SendingModal.vue?vue&type=template&id=2f4a6050&"
import script from "./SendingModal.vue?vue&type=script&lang=js&"
export * from "./SendingModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports